import { environment } from './../../../../environments/environment';
import { PaymentTerminalService } from './../../../services/payment-terminal/payment-terminal.service';
import { ActivatedRoute, Router} from '@angular/router';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { Component, OnInit} from '@angular/core';
import { Platform } from "@ionic/angular";

import { IPaymentTerminal} from '../payment-terminal/IPayment-terminal.model';
import { StorageService } from 'src/app/services/storage/storage.service';
import { KEY_LAST_CATEGORY_SELECT } from '../payment-terminal/payment-terminal.page';


@Component({
  selector: 'app-brands',
  templateUrl: './brands.page.html',
  styleUrls: ['./brands.page.scss'],
})
export class BrandsPage implements OnInit {

  public id: string;
  PaymentData: IPaymentTerminal
  brands 
  category
  loading = true;
  sizeT : any
  desktop : boolean
  public_id_cloudinary = environment.public_id_cloudinary
  constructor( public languageService: LanguagesService,
    private brandsService: PaymentTerminalService,
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private platform:Platform,

    ) { }
    
   async ngOnInit() {

    if(this.platform.is("desktop")){
      this.sizeT = 2
      this.desktop = true
    } else {
      this.sizeT = 6
      this.desktop = false
    }
    
    }
    async ionViewDidEnter(){
      this.id = this.route.snapshot.paramMap.get('id');
      await this.getBrands(this.id);
      this.category = await this.storageService.get(KEY_LAST_CATEGORY_SELECT)
      console.log(this.category);
      

    }
    
    async getBrands(id?){
      
      const brands : any = id
       ? await this.brandsService.getBrandsByCategory(id)
       :  await this.brandsService.getBrands();
      this.brands = brands.data
      this.loading = false
  }

  openbrandsId(brand){
    this.router.navigate([`app/brands`,this.id,'brand-detail', brand.id]);
  }

  get getTextsIUPagePaymenterminalServices() {
    return this.languageService.textsIU.page_payment_terminal
  }
}
